export const BOOTSTRAP_BREAKPOINTS = {
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
    XXL: 1400,
} as const;

export enum Region {
    SmallRegion = 'SmallRegion',
    MediumRegion = 'MediumRegion',
    LargeRegion = 'LargeRegion',
    DesktopRegion = 'DesktopRegion',
    LargeDesktopRegion = 'LargeDesktopRegion',
    Unknown = 'Unknown',
}
